export default __webpack_public_path__ + "static/media/cover.50946b05.JPG";